import us_pc from "./../../assets/images/us_pc.webp";
import us_mo from "../../assets/images/us_mo.webp";

import ar_white from "../../assets/images/ar_white.svg";
import home_white from "../../assets/images/home_white.svg";

export default function ContactUsBanner() {
  return (
    <div className="w-full ">
      <div
        className="block md:hidden lg:hidden w-full relative  h-[12rem] mt-16 bg-center bg-cover bg-no-repeat"
        style={{
          backgroundImage: `url(${us_mo})`,
        }}
      >
        <div className="w-full  h-[12rem] bg-blue-sky-gradient6  ">
          <div className="w-full mx-auto flex flex-col gap-2 items-center justify-center pt-14">
            <div className="w-full h-[2.625rem] rounded-[40px] flex items-center gap-2 justify-center ">
              <div className="flex items-center gap-2">
                <img src={home_white} alt="home1" />
                <img src={ar_white} alt="ar" />
              </div>
              <div>
                <p className="text-[1rem] font-normal text-white ">Liên hệ</p>
              </div>
            </div>
            <p className="text-[1.5rem] font-semibold text-white whitespace-nowrap">
              Liên hệ với chúng tôi
            </p>
          </div>
        </div>
      </div>
      <div
        className="hidden md:block lg:block w-full relative h-[20rem] mt-28 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url(${us_pc})`,
        }}
      >
        <div className="w-full  h-[20rem] bg-blue-sky-gradient6">
          <div className=" flex flex-col gap-2 items-center justify-center w-full mx-auto pt-28">
            <div className="w-full h-[2.625rem] rounded-[40px] flex items-center justify-center">
              <div className="flex items-center gap-2">
                <img src={home_white} alt="home1" />
                <img src={ar_white} alt="ar" />
              </div>
              <div>
                <p className="text-[1rem] font-normal text-white whitespace-nowrap">
                  Về chúng tôi
                </p>
              </div>
              <img src={ar_white} alt="ar" />
              <div>
                <p className="text-[1rem] font-normal text-white pl-4">
                  Liên hệ
                </p>
              </div>
            </div>
            <p className="text-[2.25rem] font-semibold text-white">
              Liên hệ với chúng tôi
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
